import Moment from "moment";
import { fieldValidationTypes, dateFormat } from "./viewUtility";
export const updateObject = (oldObject, updatedProperties) => {
  return {
    ...oldObject,
    ...updatedProperties,
  };
};

export const checkValidity = (value, rules) => {
  let isValid = true;
  let invalidRule = null;
  if (!rules) {
    return true;
  }
  if (rules.required) {
    isValid = CommonUtil.isNotNull(value) && String(value).trim() !== "" && value !== false && isValid;
    invalidRule = !isValid && invalidRule === null ? "required" : invalidRule;

    if (rules.radioSelect) {
      isValid = String(value) === "1" || String(value) === "0";
      invalidRule = !isValid && invalidRule === null ? "radioSelect" : invalidRule;
    }
    if (rules.minLength) {
      isValid = String(value).length >= rules.minLength && isValid;
      invalidRule = !isValid && invalidRule === null ? "minLength" : invalidRule;
    }

    if (rules.maxLength) {
      isValid = value.length <= rules.maxLength && isValid;
      invalidRule = !isValid && invalidRule === null ? "maxLength" : invalidRule;
    }
    if (rules.isAlphabet) {
      isValid = CommonUtil.ALPHABET_REGEX.test(value) && isValid;
      invalidRule = !isValid && invalidRule === null ? "isAlphabet" : invalidRule;
    }
    if (rules.isAlphabetSpace) {
      isValid = CommonUtil.ALPHABET_SPACE_REGEX.test(value) && isValid;
    }
    if (rules.isEmail) {
      const isEmailValid = CommonUtil.validateEmail(value);
      return { isValid: isEmailValid, invalidRule: "isEmail" };
    }

    if (rules.isMobile) {
      isValid = CommonUtil.validateMobile(value) && isValid;
      invalidRule = !isValid && invalidRule === null ? "isMobile" : invalidRule;
    }

    if (rules.isNumeric) {
      const pattern = /^\d+$/;
      isValid = pattern.test(value) && isValid;
      invalidRule = !isValid && invalidRule === null ? "isNumeric" : invalidRule;
      if (isValid) {
        if (rules.min) {
          isValid = Number(value) >= rules.min;
          invalidRule = !isValid && invalidRule === null ? "min" : invalidRule;
        }
      }
    }

    if (rules.isIfsc) {
      let regex = new RegExp(/^[A-Z]{4}0[A-Z0-9]{6}$/);
      isValid = regex.test(value) && isValid;
      invalidRule = !isValid && invalidRule === null ? "isIfsc" : invalidRule;
    }

    if (rules.isPanNo) {
      //const pattern = /[A-Za-z]{3}(?:p|P)[a-zA-Z]{1}[0-9]{4}[a-zA-Z]{1}/;
      const pattern = /^([330a-zA-Z]){5}([0-9]){4}([a-zA-Z]){1}?$/;
      isValid = pattern.test(value) && isValid;
      invalidRule = !isValid && invalidRule === null ? "isPanNo" : invalidRule;
    }
    if (rules.isPinCode) {
      const pattern = /^[1-9][0-9]{5}$/;
      isValid = pattern.test(value) && isValid;
      invalidRule = !isValid && invalidRule === null ? "isPinCode" : invalidRule;
    }
    if (rules.isDate) {
      const pattern = /^(0[1-9]|1\d|2\d|3[01])\/(0[1-9]|1[0-2])\/(19|20)\d{2}$/;
      //value = Moment(value).format("DD/MM/YYYY");
      isValid = pattern.test(value) && isValid;
      invalidRule = !isValid && invalidRule === null ? "isDate" : invalidRule;
    }
    if (rules.isDOBDate) {
      let momentValue = Moment(value, "DD/MM/YYYY", true);
      isValid = momentValue.isValid() && isValid;
      invalidRule = !isValid && invalidRule === null ? "isDOBDate" : invalidRule;
    }
    if (rules.isInRange && isValid && (Number(value) < rules.isInRange.min || Number(value) > rules.isInRange.max)) {
      isValid = false;
      invalidRule = "isInRange";
    }
  }

  return {
    isValid,
    invalidRule,
  };
};



export const tableListTypes = {
  HOLD: "hold",
  SERVICE_REQUEST: "serviceRequest",
  BANK_STATEMENTS: "bankStatements",
  CUSTOMER_SERVICE_REQUESTS: "customerServiceRequests",
};

export const ApiEndpoints = {
  // Common API end points 
  TABS_AND_FILTER: "/service-request/generic/fetchTabsAndFilters",
  SIGN_IN: "/service-request/ws/auth/login",
  FETCH_SR_DETAILS: "/service-request/details",
  FETCH_CUSTOMER_DETAILS: "/service-request/cutomerDetails",
  CREATE_SERVICE_REQUEST: "/service-request/ticket",
  GET_CATEGORY: "/service-request/category",
  GET_SUB_CATEGORY: "/service-request/sub-category",
  FETCH_SR_STATUS_OPTIONS: "/service-request/status/all",
  UPDATE_SR_STATUS: "/service-request/status/update",


  // Customer details API's
  FETCH_CUSTOMER_USER_DETAILS: "/service-request/user-details",
  FETCH_CUSTOMER_BANK_DETAILS: "/service-request/bank-details",
  FETCH_CUSTOMER_BANK_STATEMENTS: "/service-request/bank-statement",
  
  
  LIST: {
    serviceRequest: "/service-request/get-list",
    bankStatements: "/service-request/bank-statement",
    customerServiceRequests: "/service-request/cust/all",
  },

};

export function combineStyles(...styles) {
  return function CombineStyles(theme) {
    const outStyles = styles.map((arg) => {
      // Apply the "theme" object for style functions.
      if (typeof arg === "function") {
        return arg(theme);
      }
      // Objects need no change.
      return arg;
    });

    return outStyles.reduce((acc, val) => Object.assign(acc, val));
  };
}

export const CommonUtil = {
  RES_PATH: "https://dugtmg0pklp2w.cloudfront.net/",
  EMAIL_REGEX: /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,20}$/,
  ALPHABET_REGEX: /^[a-zA-Z]*$/,
  NAME: /^[a-z .]+$/i,
  ALPHABET_SPACE_REGEX: /^[a-zA-Z ]*$/,
  MOBILE_REGEX: /^[6789]\d{9}$/,
  DIGIT_REGEX: /^[0-9\b]+$/,
  //Masking email Regex
  BASIC_EMAIL_MASK: /^([@])/g,
  INR: "₹",
  trimText(str, lenght = 30) {
    if (str && str.substring) {
      if (str.length > lenght) {
        return str.substring(0, lenght).trim() + "...";
      } else {
        return str;
      }
    } else {
      return str;
    }
  },
  isLoggedIn() {
    return false;
  },
  isError(controls) {
    return controls.valid && !controls.valid.isValid && controls.touched;
  },
  getHelperTxt(controls) {
    // if required,touched and value is entered and then not valid : inValid Error
    // else no value being entered

    if (controls.validations && controls.touched && !controls.valid.isValid) {
      return controls.validations.messages[controls.valid.invalidRule];
    }

    if (controls.dynamicHelperTextHeight) {
      return controls.helperText ? controls.helperText : "";
    }

    if (controls.validations) {
      // Empty sting is  added to have pre-allocated space for error messages
      // to prevent flickering.  We only added empty string  if validation rules prevent
      return controls.helperText ? controls.helperText : " ";
    }
    return controls.helperText;
  },
  isNull(data) {
    return data === undefined || data === null;
  },
  isNotNull(data) {
    return !this.isNull(data);
  },
  validateEmail(value) {
    let email = String(value).toLowerCase();
    return email && this.EMAIL_REGEX.test(email);
  },

  validateMobile(number) {
    return number && this.MOBILE_REGEX.test(String(number));
  },
  toMoney(amount) {
    return Math.ceil(parseFloat(amount)).toLocaleString("en-IN");
  },
  toFromNow(date) {
    if (!date) {
      return "";
    }
    return Moment(date).fromNow();
  },
  toPercent(value) {
    if (value === "" || value === undefined || value === null) {
      return value;
    }
    value = Math.round((value + Number.EPSILON) * 100) / 100;

    return `${value}%`;
  },
  toMoneyWithSymbol(amount, delimiter) {
    if (typeof delimiter === "undefined") {
      delimiter = "";
    }

    if (amount === "") {
      return "";
    }

    if (CommonUtil.isNotNull(amount)) {
      const amt = amount > 0 ? amount : 0;
      return this.INR + delimiter + this.toMoney(amt);
    }
  },
  getDateShortYearMonth(value) {
    return Moment(value, "MMM YYYY").format("MMM'YY");
  },
  kFormatter(num) {
    return Math.abs(num) > 999 ? Math.sign(num) * (Math.abs(num) / 1000).toFixed(1) + "k" : Math.sign(num) * Math.abs(num);
  },
  inputCheck(type, { event }) {
    if (type.includes(fieldValidationTypes.POSITIVE_NUMBER)) {
      const keyCode = event.keyCode || event.charCode;
      const isValid = keyCode === 8 || keyCode === 0 || keyCode === 13 ? null : keyCode >= 48 && keyCode <= 57;
      if (!isValid) {
        event.preventDefault();
        return false;
      }
    }
    if (type.includes(fieldValidationTypes.MOBILE_NUMBER)) {
      if (event.target.value.length > 10) {
        event.preventDefault();
        return false;
      }
    }
    return true;
  },
  handleNull(value, options) {
    options = { suffix: "", placeHolder: "-", ...options };
    if (typeof value === "undefined" || value === null || value === "") {
      return options.placeHolder;
    }
    return options.suffix ? value + options.suffix : value;
  },
  getFreeChatTimeLeft(date, format = dateFormat.formatDateTimeServer, diffType = "second") {
    const startTime = Moment();
    const endTime = Moment(date, format).add(24, "hours");
    const diff = endTime.diff(startTime, diffType);
    return diff;
  },
  getAgentChatTimeLeft(date, format = dateFormat.formatDateTimeServer, diffType = "second") {
    const startTime = Moment();
    const endTime = Moment(date, format).add(15, "minutes");
    const diff = endTime.diff(startTime, diffType);
    return diff;
  },
  getFormattedMinCounterFromMins(mins) {
    if (mins <= 0) {
      return "00:00";
    }
    var h = (mins / 60) | 0,
      m = mins % 60 | 0;
    return `${this.getDoubleDigitNumber(h)}:${this.getDoubleDigitNumber(m)}`;
  },
  getFormattedSecCounterFromSeconds(sec) {
    if (sec <= 0) {
      return "00:00";
    }
    var m = (sec / 60) | 0,
      s = sec % 60 | 0;
    return `${this.getDoubleDigitNumber(m)}:${this.getDoubleDigitNumber(s)}`;
  },
  getChatDate(date) {
    return getFormattedDate(Number(date));
  },
  getDoubleDigitNumber(n) {
    return n > 9 ? "" + n : "0" + n;
  },
  replace(str, mapList) {
    mapList.forEach((element) => {
      var replace = element.placeholder;
      var re = new RegExp(replace, "g");
      str = str.replace(re, element.value);
    });
    return str;
  },
  toClientDate(date) {
    if (!date) {
      return date;
    }
    return Moment(date, dateFormat.formatDateTimeServer).format(dateFormat.formatServer);
  },
  downloadURI(uri, name) {
    let link = document.createElement("a");
    link.download = name;
    link.href = uri;
    link.style.display = "none";
    link.click();
    link.remove();
  },
  toMonthText(value) {
    if (value) return value + " Mo.";
  },
  openInNewTab(url) {
    url && window.open(url, "_blank");
  },
  urlParamsToParamsObject(url) {
    const searchParams = new URLSearchParams(url);
    const result = {};
    for (const [key, value] of searchParams.entries()) {
      result[key] = value;
    }
    return result;
  },
};

export const getFormattedDate = (date, handleNull) => {
  if (handleNull && !date) return "-";
  return Moment(date).format(dateFormat.formatClientV2);
};


export const copyToClipboard = (text) => {
  navigator.clipboard.writeText(text);
};

export default CommonUtil;
